module.exports = __webpack_public_path__ + "assets/img/EISS-Super-eBook-w960.fae0b1d8.jpg";